<template>
  <div class="sale-market-head mb40">
    <!-- <h3>{{'Sale Market'|translate}}</h3> -->
    <div v-if="user">
      <router-link :to="{ name: 'SaleMarketOrderList', params: { profileId: user.id }}">
        <i class="fas fa-shopping-bag"></i>
        {{'My order'|translate}}
      </router-link>&nbsp;&nbsp;
      <router-link :to="{name:'FavoriteStores'}">
        <i class="fas fa-heart"></i>
        {{'Favorited stores'|translate}}
      </router-link>&nbsp;&nbsp;
      <router-link v-if="user.retailer " :to="{name:'SaleMarketSellerOrders'}">
        <i class="fas fa-cubes"></i>
        {{"User's order"|translate}}
      </router-link>&nbsp;&nbsp;
      <router-link v-if="user.retailer" :to="{ name: 'ManageSaleMarket'}">
        <i class="fas fa-list"></i>
        {{'Manage Sale Market'|translate}}
      </router-link>&nbsp;&nbsp;
      <router-link :to="{ name: 'SaleMarkeCart'}" v-if="count_carts > 0">
        <i class="fas fa-shopping-cart"></i>
        {{'cart'|translate}} ({{count_carts}})
      </router-link>
    </div>
  </div>
</template>
<script>
// http://farmbook.com/API/listProduct
import Utils from "@/helpers/utils";

export default {
  name: "SaleMarketHead",
  components: {},
  data() {
    let data = {
      user: null,
      count_carts: 0
    };
    return data;
  },
  methods: {
    getRoleName(role_id) {
      let name = Utils.getRoleName(role_id);
      return name;
    },
    getListCarts() {
      
      Utils.request(this, true, "salemarket")
        .get(`/listCart/`)
        .then(response => {
          let data = response.data;
          if (data.status === "ok") {
            this.count_carts = data.data;
          }
        })
        .catch(error => {
          this.working = false;
          Utils.showErrorMessage(this, error.response);
        });
      return;
    }
  },
  mounted() {
    this.user = Utils.getUser(this);
    
    this.getListCarts();
  }
};
</script>



// WEBPACK FOOTER //
// src/components/SaleMarket/SaleMarketHead.vue